import { render, staticRenderFns } from "./authCompleted.vue?vue&type=template&id=2df76c02&scoped=true"
import script from "./authCompleted.vue?vue&type=script&lang=js"
export * from "./authCompleted.vue?vue&type=script&lang=js"
import style0 from "./authCompleted.vue?vue&type=style&index=0&id=2df76c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df76c02",
  null
  
)

export default component.exports